import { HomePagePeriod } from "./enums";

export class DashboardDataResponse {
    totalUploadAmount = 0;
    amountUsedByEmployees = 0;
    totalAvailableBalance = 0;
    unpaidSubsidies = 0;
    creditBalance = 0;
    totalBudget: TotalBudgetPercentResource | null = null;
    orderSummary: OrderSummaryResource | null = null;
    doughnutData: DashboardDoughnutResource | null = null;
}

export class OrderSummaryResource {
    ordersWithSubsidies: number[] | null = null;
    ordersWithoutSubsidies: number[] | null = null;
    totalOrders: number[] | null = null;
    orderSummaryLabels: string[] | null = null;
}

export class DashboardDoughnutResource {
    firstMonthOfCurrentYear: string | null = null;
    used: number | null = null;
    left: number | null = null;
    usedPercent: number | null = null;
    leftPercent: number | null = null;
}

export class DashboardBudgetResponse {
    usedPointsAccumulated: number[] | null = null;
    obligoBalancePoints: number[] | null = null;
    usedPoints: number[] | null = null;
    budgetLabels: string[] | null = null;
}

export class DashboardDataRequest {
    orderSummarySelect: HomePagePeriod = HomePagePeriod.ByMonth;
    totalUsedSelect: HomePagePeriod = HomePagePeriod.ByMonth;
}

export class TotalBudgetPercentResource {
    totalUsedBudget: number | null = null;
    totalBudgetPercent: number | null = null;
    percentTextShow: boolean = false;
    currencyId = 0;
}
